import React, { useState } from "react";
import styles from "./styles.module.css";
import { InteractiveMap } from "../../components/maps/InteractiveMap";
import styled from "styled-components";
import 'leaflet/dist/leaflet.css';
import { MapWithPoligons } from "../../components/MapWithPoligons";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const Home = () => {
  return (
    <Container>
      <Content>
        <div className={styles.mapBackground} style={{ width: '100%', height: '100%' }}>
          {/* <InteractiveMap latitude={41.5089324} longitude={74.724091} /> */}
          <MapWithPoligons   
            type={["REGION"]}
          />
        </div>
      </Content>
    </Container>
  );
};
